/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import GuidanceSessionsDash from "../../components/GuidanceSessions";
import Navbar from "../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";

const GuidanceSessions = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } =
    useSelector((state) => state?.reducer?.authInfo) || {};

  const ROOT_URL = backendUrlByEnv(env);

  useEffect(() => {
    if (!userConfig?.guidanceSessions?.hasAccess) {
      navigate(LOGIN);
    }
  }, []);

  return (
    <>
      <Navbar />
      <GuidanceSessionsDash userConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default GuidanceSessions;
